import { TContent } from "."

const cookiesTerms: TContent[] = [
  {
    type: "documentTitle",
    content: "Política de cookies",
  },
  {
    type: "text",
    content:
      "CONDHELP SOLUÇÕES Ltda., através desta Política de Cookies tem o objetivo de fornecer informações claras sobre o uso e função dos cookies nas plataformas CONDHELP, indicando quais são as diretrizes adotadas em respeito à privacidade de todos os usuários, clientes e/ou visitantes do site ou Sistema CONDHELP, em complemento à nossa Política de Privacidade.",
  },
  {
    type: "text",
    content:
      "Ao acessar o nosso site ou aplicativo, o usuário autoriza o uso de cookies de acordo com a presente Política. Caso não concorde com o uso de cookies na forma descrita, o usuário poderá ajustar as configurações de seu navegador para não permitir o seu uso.",
  },
  {
    type: "title",
    content: "O que são cookies",
  },
  {
    type: "text",
    content:
      "Um cookie é um pequeno arquivo instalado por meio do navegador do usuário quando o website CONDHELP é acessado. Esse arquivo é armazenado no computador ou dispositivo móvel e fica acessível a nossos servidores para coleta de informações que nos permitirão aprimorar a usabilidade e a experiência de navegação em nossos portais.",
  },
  {
    type: "text",
    content:
      "Os cookies atuam como um registro das atividades do usuário, e são atualizados todas as vezes em que o website for acessado, permitindo que este reconheça o usuário e lembre de informações importantes que tornam a utilização da nossa plataforma mais agradável. Os cookies não coletam qualquer informação ou dado pessoal armazenados em dispositivo móvel ou computador.",
  },
  {
    type: "title",
    content: "O objetivo do uso de cookies",
  },
  {
    type: "text",
    content:
      "O objetivo da utilização de cookies no nosso website e Sistema é fazer a distinção entre os usuários, personalizando o conteúdo e melhorando a experiência de acordo com as preferências do usuário.",
  },
  {
    type: "text",
    content:
      "Os cookies podem ser utilizados para tornar a interação entre o usuário e o website mais rápida e fácil, além de lembrar das preferências do usuário, informações relacionadas a suas atividades no website visitado, ou coletar informações que podem ser usadas para oferecer conteúdo ou comunicações diretas ou de marketing de uma forma personalizada.",
  },
  {
    type: "text",
    content:
      "Os cookies também são utilizados para analisar o desempenho do nosso website para que possamos fazer melhorias e torná-los mais fácil de usar, bem como para identificar o canal de origem do usuário.",
  },
  {
    type: "text",
    content:
      "Utilizamos cookies analíticos para monitorar o desempenho do nosso website e gerar relatórios de uso, como o número de visitas, as páginas mais acessadas e o tempo de navegação. Essas informações são anonimizadas e usadas exclusivamente para otimizar a experiência do usuário e identificar áreas que necessitam de melhorias.",
  },
  {
    type: "title",
    content: "Dados coletados pelos cookies",
  },
  {
    type: "text",
    content:
      "Quando o usuário visita nosso website, empregamos cookies para que possamos coletar automaticamente os seguintes dados:",
  },
  {
    type: "text",
    content:
      "informações técnicas como o tipo de equipamento que você utiliza, o sistema operacional empregado, o navegador utilizado e o endereço de IP. Estes dados são empregados apenas para fins estatísticos e para aprimorar a experiência de navegação em nossos portais;",
  },
  {
    type: "text",
    content:
      "informações sobre a experiência de navegação em nosso website, como por exemplo as seções visitadas, produtos e serviços visualizados, o tempo de visualização e referência externas que o levaram ao nosso website. Estas informações são empregadas para que possamos aprimorar a estrutura de nossos portais e para eventual direcionamento de ofertas de nossos produtos e serviços;",
  },
  {
    type: "text",
    content:
      "informações sobre suas preferências pessoais, como idioma de navegação e país de origem, utilizado no propósito de adotar essas preferências como padrão a cada nova visita sua em nossos portais.",
  },
  {
    type: "title",
    content: "Funções dos cookies",
  },
  {
    type: "text",
    content:
      "Os cookies utilizados pela CONDHELP executam as seguintes funções:",
  },
  {
    type: "text",
    content:
      "Cookies Necessários: São essenciais para o funcionamento correto do nosso website e para manter sua segurança. Esse tipo de cookie é definido para resposta a ações feitas pelo usuário, traduzindo-se em solicitação de serviços, como, por exemplo, definir suas preferências de privacidade, efetuar login ou preencher formulários.",
  },
  {
    type: "text",
    content:
      "Cookies Funcionais: Servem para lembrar das configurações e preferências feitas pelo usuário ou ajudar com outras funcionalidades durante a navegação no website.",
  },
  {
    type: "text",
    content:
      "Cookies de Terceiros: É possível a disponibilização de conteúdo de terceiros em nossos websites e portais, a exemplo de vídeos, imagens, artigos e pesquisas de serviços de mídia social como Instagram, Linkedin, Facebook, Twitter, Youtube, Itunes, etc. Ao acessar o conteúdo desses provedores, é provável que cookies destes terceiros sejam instalados em seus dispositivos. A CONDHELP não possui ingerência ou controle sobre o uso, finalidade e funcionamento destes cookies. Recomendamos que busque conhecer a política de cookies desses provedores para mais informações.",
  },
  {
    type: "text",
    content:
      "Abaixo estão listados os cookies que utilizamos em nosso site, suas finalidades e a duração de cada um:",
  },
  {
    type: "table",
    content: {
      columns: ["Nome do cookie", "Finalidade", "Duração", "Categoria"],
      items: [
        [
          "_ga",
          "Análise de tráfego do Google Analytics",
          "2 anos",
          "Analítico",
        ],
        [
          "_gid",
          "Distinção de usuários no Google Analytics",
          "24 horas",
          "Analítico",
        ],
        ["session_cookie", "Manter login de sessão", "Sessão", "Necessário"],
        [
          "marketing_cookie",
          "Direcionamento de publicidade personalizada",
          "1 mês",
          "Marketing",
        ],
      ],
    },
  },
  {
    type: "text",
    content:
      "Para informações sobre cookies de terceiros, como Google Analytics e YouTube, recomendamos a consulta às políticas de cookies desses provedores.",
  },
  {
    type: "title",
    content: "Controle e restrição dos cookies",
  },
  {
    type: "text",
    content:
      "O usuário tem o direito de escolher se deseja permitir o uso de cookies em seu dispositivo, as autorizações para coleta de cookies serão obtidas no primeiro acesso a nosso website e poderão ser alteradas de acordo com a sua preferência em seu navegador.",
  },
  {
    type: "text",
    content:
      "Pelo navegador, o usuário pode alterar suas preferências de cookies a qualquer momento, no entanto, ressaltamos que os cookies são uma parte importante do funcionamento dos nossos serviços, e o bloqueio de cookies poderá resultar na perda de funcionalidades ou restrição de acesso a seções de nosso website.",
  },
  {
    type: "text",
    content:
      "No primeiro acesso ao nosso website, o usuário será solicitado a fornecer seu consentimento explícito para o uso de cookies, com a possibilidade de aceitar ou rejeitar determinados tipos de cookies (funcionais, analíticos e de marketing). O usuário pode a qualquer momento revisar e modificar suas preferências de cookies acessando a seção de configurações de privacidade disponível no rodapé do website.",
  },
  {
    type: "text",
    content:
      "O usuário pode, a qualquer momento, revogar o consentimento fornecido para o uso de cookies, acessando as configurações do navegador ou utilizando a nossa ferramenta de gerenciamento de cookies disponível no website. A revogação do consentimento pode impactar a experiência de navegação, resultando na desativação de algumas funcionalidades.",
  },
  {
    type: "title",
    content: "Informações adicionais",
  },
  {
    type: "text",
    content:
      "Os termos desta Política poderão ser modificados a qualquer momento, em razão de alterações legislativas, em decorrência da atualização de ferramentas tecnológicas ou a critério da CONDHELP, por isso, recomendamos que sempre verifique a Política de Cookies vigente.",
  },
  {
    type: "text",
    content:
      "As informações coletadas serão sempre processadas em conformidade com esta Política e com a Política de Privacidade.",
  },
  {
    type: "text",
    content:
      "Esta Política é regida exclusivamente pelas Leis da República Federativa do Brasil.",
  },
  {
    type: "text",
    content:
      "Toda e qualquer questão oriunda desta Política será solucionada junto ao foro da comarca de São José, Estado de Santa Cataria, com exclusão de qualquer outro por mais privilegiado que seja.",
  },
  {
    type: "text",
    content:
      "Caso ocorram alterações significativas nesta Política de Cookies, a CONDHELP se compromete a notificar os usuários por meio de um aviso no site ou por e-mail, informando sobre as mudanças e a data de vigência das novas condições. Recomendamos que os usuários revisem regularmente esta Política para se manterem informados sobre como utilizamos cookies.",
  },
  {
    type: "text",
    content:
      "Para maiores informações sobre os cookies e utilização de dados pela CONDHELP, leia a Política de Privacidade da CONDHELP.",
  },
  {
    type: "text",
    content: "São José, 30 de novembro de 2024.",
  },
  {
    type: "text",
    content: "CONDHELP SOLUÇÕES LTDA.",
  },
  {
    type: "text",
    content: "CNPJ: 53.288.559/0001-25",
  },
]

export default cookiesTerms
